import {
  INICIA_DISCIPLINA,
  NOVO_DISCIPLINA,
  BUSCA_DISCIPLINA_EDICAO,
  CANCELA_EDICAO,
  INICIO_DISCIPLINA_SUCESSO,
  SALVA_DISCIPLINA_SUCESSO,
  REMOVE_DISCIPLINA_SUCESSO,
  BUSCA_DISCIPLINA_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  APLICA_FILTRO_DISCIPLINA,
  LISTA_DISCIPLINA,
  LISTA_DISCIPLINA_SUCESSO,
  LIMPAR_DISCIPLINA
} from "constants/ActionTypes";

const INIT_STATE = {
  colunasGrid: [
    { titulo: 'Código', propriedadeApi: 'id', alinhamento: 'left' },
    { titulo: 'Disciplina', propriedadeApi: 'nome', alinhamento: 'left' },
    { titulo: 'Área', propriedadeApi: 'areaConhecimentoNome', alinhamento: 'left' },
    { titulo: 'Educacenso', propriedadeApi: 'codigoEducacenso', alinhamento: 'left' }
  ],
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  disciplinaCarregada: null,
  id: 0,
  nome: '',
  nomeAbreviado: '',
  tipoBase: null,
  areaConhecimentoId: null,
  codigoEducacenso: null,
  ordemApresentacao: '',
  desconsideraParaProgressao: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_DISCIPLINA: {
      return { ...state, edicao: false, loader: true, carregandoLista: true };
    }
    case NOVO_DISCIPLINA: {
      return {
        ...state,
        edicao: true,
        loader: false,
        id: 0,
        nome: '',
        nomeAbreviado: '',
        tipoBase: null,
        areaConhecimentoId: null,
        codigoEducacenso: null,
        ordemApresentacao: '',
        desconsideraParaProgressao: false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case BUSCA_DISCIPLINA_EDICAO: {
      return { ...state, loader: true };
    }
    case CANCELA_EDICAO: {
      return { ...state, edicao: false };
    }
    case INICIO_DISCIPLINA_SUCESSO: {
      const retorno = action.payload || [];
      const lista = Array.isArray(retorno) ? retorno : (retorno && (retorno.disciplina || retorno.Disciplina) ? (retorno.disciplina || retorno.Disciplina) : []);
      return { ...state, loader: false, carregandoLista: false, listGrid: lista, listGridComFiltro: lista };
    }
    case SALVA_DISCIPLINA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case REMOVE_DISCIPLINA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case LISTA_DISCIPLINA: {
      return { ...state, loader: true, carregandoLista: true };
    }
    case APLICA_FILTRO_DISCIPLINA: {
      const texto = action.payload || '';
      return { ...state, textoFiltro: texto };
    }
    case LISTA_DISCIPLINA_SUCESSO: {
      const retorno = action.payload;
      const lista = Array.isArray(retorno) ? retorno : (retorno && (retorno.disciplina || retorno.Disciplina) ? (retorno.disciplina || retorno.Disciplina) : []);
      return { ...state, loader: false, carregandoLista: false, listGrid: lista, listGridComFiltro: lista };
    }
    case LIMPAR_DISCIPLINA: {
      return { ...state, textoFiltro: '' };
    }
    case BUSCA_DISCIPLINA_EDICAO_SUCESSO: {
      var retorno = action.payload;
      var base = retorno && retorno.disciplina ? retorno.disciplina : retorno;
      return {
        ...state,
        edicao: true,
        loader: false,
        disciplinaCarregada: base,
        id: base.id || base.Id || 0,
        nome: base.nome || base.Nome || '',
        nomeAbreviado: base.nomeAbreviado || base.NomeAbreviado || base.abreviatura || base.Abreviatura || '',
        tipoBase: (function() {
          const v = base.tipoBase || base.TipoBase;
          if (v !== undefined && v !== null) return v;
          const bc = base.BaseCurricular || base.baseCurricular;
          if (typeof bc === 'string') {
            const s = bc.trim().toLowerCase();
            if (s === 'base nacional comum') return 1;
            if (s === 'base diversificada') return 2;
            if (s === 'base profissional') return 3;
            if (s.indexOf('art.33') !== -1 || s.indexOf('ensino religioso') !== -1) return 4;
          }
          return null;
        })(),
        areaConhecimentoId: base.areaConhecimentoId || base.AreaConhecimentoId || base.area_conhecimento_id || null,
        codigoEducacenso: base.codigoEducacenso || base.CodigoEducacenso || base.codigo_educacenso || null,
        ordemApresentacao: base.ordemApresentacao || base.OrdemApresentacao || '',
        desconsideraParaProgressao: base.desconsideraParaProgressao || base.DesconsideraParaProgressao || false,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }
    case HIDE_MESSAGE: {
      return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false, loader: false, carregandoLista: false };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false, carregandoLista: false };
    }
    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageError: true, edicao: false, carregandoLista: false };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: state.edicao, carregandoLista: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageError: true };
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      };
    }
    case ALTERACAO_COMBO: {
      return {
        ...state,
        [action.payload.nomeCombo]: action.payload.valor,
      };
    }
    case ALTERACAO_CHECK: {
      return {
        ...state,
        [action.payload.nomeCheck]: action.payload.valor,
      };
    }
    default:
      return state;
  }
}
